import { Component, OnInit } from '@angular/core';
import { ICONS_SPRITE_PATH } from '../../../core/pipes/sprite-icon.pipe';
import { Router } from '@angular/router';
import { InAppBrowser } from '@ionic-native/in-app-browser/ngx';
import { AlertController, MenuController, Platform, ToastController } from '@ionic/angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BASE_URL_PATH, SIDE_MENU, STONE_CREEK_ABOUT_URL, STONE_CREEK_MERCHANT_ID, STORAGE_CUSTOMER_DATA } from 'src/app/core/constants';
import { Platforms } from 'src/app/core/enums/util.enum';
import { Customer, CustomerData } from 'src/app/core/models/customer.model';
import { MerchantMobileApp, MobileAppMenuTab, SideMenu } from 'src/app/core/models/restaurant.model';
import { PaymentService } from 'src/app/core/services/payment.service';
import { RouteService } from 'src/app/core/services/route.service';
import { StorageService } from 'src/app/core/services/storage.service';
import { UtilService } from 'src/app/core/services/util.service';
import { CartStore } from 'src/app/core/stores/cart.store';
import { MerchantStore } from 'src/app/core/stores/merchant.store';
import { PaymentStore } from 'src/app/core/stores/payment.store';
import { merchantConfig } from 'src/environments/merchant-config';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent implements OnInit {
  public sideMenu = SIDE_MENU;
  private destroyed$ = new Subject<void>();
  public customer: Customer = null;
  public merchantMobileApp:MerchantMobileApp;
  public mobileAppMenuTabs: MobileAppMenuTab[] = [];
  public remove:boolean = false;

  constructor(
    private menuCtrl: MenuController,
    public utilService: UtilService,
    private router: Router,
    private cartStore: CartStore,
    private platform: Platform,
    public paymentStore: PaymentStore,
    private storageService: StorageService,
    private merchantStore: MerchantStore,
    private alertController: AlertController,
    private paymentService: PaymentService,
    private routeService: RouteService,
    private toastController: ToastController,
    private iab: InAppBrowser
  ) {
  }

  ngOnInit() {
    // this.checkPlatform();
    this.getCustomer();
    this.merchantStore.merchantMobileApp$.subscribe((merchantMobileApp)=>{
      this.merchantMobileApp = merchantMobileApp;
    })

    this.merchantStore.mobileAppMenuTabs$.subscribe((mobileAppMenuTabs)=>{
      this.mobileAppMenuTabs = mobileAppMenuTabs;
    })
  }

  public closeSideMenu(): void {
    this.menuCtrl.close();
  }

  public handleNavigation(value: MobileAppMenuTab): void {
    this.closeSideMenu();
    if(value.redirect && value.redirectUrl && value.redirectUrl.includes("facebook")){
      this.iab.create(value.redirectUrl, '_system');
    } else if(value.redirect && value.redirectUrl){
      this.utilService.openInAppBrowser(value.redirectUrl);
    } else if(!value.redirect && value.content) {
      this.utilService.navigateToContentPage(value, this.merchantMobileApp.id);
    }
  }

  private checkPlatform(): void {
    if (!this.platform.is(Platforms.CORDOVA)) {
      this.sideMenu = this.sideMenu.map((item) => {
        if (item.id === 1) {
          item.hide = true;
        }
        return item;
      });
    }
  }

  public navigateToAccount(): void {
    if (this.paymentStore.verificationCustomer) {
      this.closeSideMenu();
      this.utilService.navigateToAccount();
    }
  }

  public async showRemoveAccountAlert(): Promise<void> {
    const alert = await this.alertController.create({
      header: 'Remove Account',
      message: `Are you sure you want to remove your account ${this.customer.phone}? This action cannot be undone.`,
      buttons: [
        {
          text: 'Cancel',
          role: 'cancel',
          cssClass: 'secondary',
        },
        {
          text: 'Remove',
          handler: () => this.removeAccount(),
        },
      ],
    });
    await alert.present();
  }

  private removeAccount(): void {
    this.paymentStore.resetCustomerData()
    let merchantId = this.routeService.getMerchantId();
    this.paymentService.removeAccount(merchantId, this.customer.squareCustomerId)
    .subscribe({
      next: (response) => {
        this.paymentStore.resetCustomerData()
        this.storageService.set(
          STORAGE_CUSTOMER_DATA,
          new CustomerData()
        );
        this.showToast('Account removed successfully');
      },
      error: (error) => {
        console.error('Failed to remove account:', error);
        this.showToast('Failed to remove account contact apps@kyoo.tech', 'danger');
      }
    });
  }

  private async showToast(message: string, color: string = 'success') {
    const toast = await this.toastController.create({
      message,
      duration: 3000,
      position: 'middle', 
      color,
    });
    await toast.present();
  }

  private async getCustomer():Promise<void> {
    const customerStorageData = await this.storageService.get(STORAGE_CUSTOMER_DATA);
    this.paymentStore.customer$.subscribe((customer: Customer) => {
      if (this.paymentStore.customer?.phone && this.paymentStore.customer?.orderBotUserId && this.paymentStore.customer?.squareCustomerId) {
        this.customer = customer
      }
    });
  }

  public getMenuItemIcon(item: SideMenu): string {
    return `${ICONS_SPRITE_PATH}#${item.icon}`;
  }
}
